import { LOGIN_USER, LOGIN_USER_NOT_FOUND } from "../config/types";

const initialState = {
  loginUser: false,
  userNotFound: false,
};

const userReducer = (state = initialState, { type }) => {
  switch (type) {
    case LOGIN_USER:
      return { userNotFound: false, loginUser: true };
    case LOGIN_USER_NOT_FOUND:
      return { userNotFound: true, loginUser: false };
    default:
      return state;
  }
};

export default userReducer;
